import apiClient from "./client";

/**
 * Combo recharge — frontend API wrappers.
 *
 * Every call goes to OUR backend (portal_php/customer/combo/combo_*.php); the
 * provider tokens never reach the browser.
 *
 * Superadmin (manage combos)
 *   comboCatalog()                 plans available to put in a combo
 *   comboAdminList()               every combo with its plans
 *   comboAdminSave(payload)        create / update a combo
 *   comboAdminStatus(id, action)   "activate" | "deactivate" | "delete"
 *
 * Superadmin + admin (hand combos out, with a price)
 *   comboAssignGet(operatorId)
 *   comboAssignSave(operatorId, assignments)
 *
 * Customer page
 *   comboForCustomer(userId)       combos this customer can be sold
 *   comboRecharge(payload)         buy one (wallet charged ONCE)
 *   comboRecheck(itemId, confirm)  re-verify / re-send one failed provider
 *   comboHistory(userId)           past combo recharges + per-provider status
 */

export const comboCatalog = () => apiClient.get("/customer/combo/combo_catalog.php");

export const comboAdminList = () => apiClient.get("/customer/combo/combo_admin_list.php");

export const comboAdminSave = (payload) =>
  apiClient.post("/customer/combo/combo_admin_save.php", payload);

export const comboAdminStatus = (id, action) =>
  apiClient.post("/customer/combo/combo_admin_status.php", { id, action });

export const comboAssignGet = (operatorId) =>
  apiClient.get(`/customer/combo/combo_assign_get.php?operator_id=${operatorId}`);

export const comboAssignSave = (operatorId, assignments) =>
  apiClient.post("/customer/combo/combo_assign_save.php", {
    operator_id: operatorId,
    assignments,
  });

export const comboForCustomer = (userId) =>
  apiClient.get(`/customer/combo/combo_for_customer.php?user_id=${userId}`);

export const comboRecharge = (payload) =>
  apiClient.post("/customer/combo/combo_recharge.php", payload);

export const comboRecheck = (itemId, confirmRetry = false) =>
  apiClient.post("/customer/combo/combo_recheck.php", {
    item_id: itemId,
    confirm_retry: confirmRetry,
  });

export const comboHistory = (userId) =>
  apiClient.get(`/customer/combo/combo_history.php?user_id=${userId}`);

/** Branches the customer's operator may recharge Pioneer IPTV under (existing endpoint). */
export const comboPioneerBranches = (operatorId) =>
  apiClient.get(`/customer/get_pioneeriptv_branches.php?operator_id=${operatorId}`);
